module.exports = __webpack_public_path__ + "static/img/3.ba5053f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/3.png
// module id = Xise
// module chunks = 45